<div
  class="modal fade disbursement-revision-dialog"
  [class.disbursement-revision-dialog-stacked]="stackAboveModal"
  [id]="modalId"
  tabindex="-1"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered disbursement-revision-dialog-container"
    [class.disbursement-revision-dialog-container-wide]="showPicker"
  >
    <div class="modal-content disbursement-revision-dialog-content">
      <div class="disbursement-revision-dialog-header">
        <div class="disbursement-revision-dialog-heading-group">
          <h5 class="disbursement-revision-dialog-title">{{ title }}</h5>
          <p *ngIf="subtitle" class="disbursement-revision-dialog-subtitle">{{ subtitle }}</p>
        </div>
        <button
          type="button"
          class="btn-close"
          aria-label="ปิด"
          [disabled]="isProcessing"
          (click)="onCancel()"
        ></button>
      </div>

      <form [formGroup]="form" class="disbursement-revision-dialog-body" (ngSubmit)="onSubmit()">
        <app-textarea
          *ngIf="!showPicker"
          label="เหตุผล"
          formControlName="reason"
          [rows]="5"
          [required]="true"
          [error]="form.controls.reason.invalid && form.controls.reason.touched ? form.controls.reason.errors : null"
        ></app-textarea>

        <section *ngIf="showPicker" class="disbursement-revision-dialog-picker-section">
          <button
            *ngIf="!showNewCourseNote()"
            type="button"
            class="app-button app-button-primary disbursement-revision-dialog-new-course-toggle"
            [disabled]="isProcessing"
            (click)="onShowNewCourseNote()"
          >
            <app-keenicon name="plus" class="fs-5"></app-keenicon>
            ขอเพิ่มรายวิชาใหม่
          </button>
          <div *ngIf="showNewCourseNote()" class="disbursement-revision-dialog-new-course-note">
            <h6>ขอเพิ่มรายวิชาใหม่</h6>
            <app-textarea
              label="รายละเอียดรายวิชาที่ต้องการเพิ่ม"
              [required]="true"
              [formControl]="newCourseNoteControl"
              [rows]="3"
              [isDisabled]="isProcessing"
              placeholder="ระบุรายละเอียดรายวิชาที่ต้องการเพิ่ม เช่น รหัสวิชา ชื่อวิชา Section ผู้สอน หรือเหตุผลเพิ่มเติม"
            ></app-textarea>
          </div>

          <h6 class="disbursement-revision-dialog-picker-heading">เลือกรายวิชาที่ต้องการแก้ไข</h6>

          <div
            *ngIf="hasSharedWorkloadSelection()"
            class="disbursement-revision-dialog-shared-workload-notice"
            role="status"
            aria-live="polite"
          >
            รายวิชาที่เลือกเป็นรายวิชาแบ่งภาระงานระหว่างผู้สอน ระบบจะเปิดแก้ไขตารางสอนของผู้สอนร่วมทั้งกลุ่ม
            และหากมีใบปะหน้าที่ออกแล้ว จะส่งให้การเงินดำเนินการยกเลิกก่อนเปิดแก้ไข
          </div>

          <div
            *ngIf="pickerRows().length === 0"
            class="disbursement-revision-dialog-picker-empty"
          >
            ไม่พบรายวิชาที่สามารถขอแก้ไขได้ในใบรับรองนี้ หากต้องการแจ้งแก้ไข กรุณาระบุรายละเอียดผ่าน “ขอเพิ่มรายวิชาใหม่”
          </div>

          <div
            *ngIf="pickerRows().length > 0"
            class="disbursement-revision-dialog-picker-table-wrap"
          >
            <table class="disbursement-revision-dialog-picker-table">
              <thead>
                <tr>
                  <th class="disbursement-revision-dialog-picker-select-col">เลือก</th>
                  <th>รายวิชา</th>
                  <th>Section</th>
                  <th>ประเภทการสอน</th>
                  <th>วันที่สอน</th>
                  <th>เวลาสอน</th>
                  <th>ห้อง</th>
                  <th>สถานะ</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of pickerRows(); trackBy: trackPickerRow">
                  <tr>
                    <td class="disbursement-revision-dialog-picker-select-col">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="row.selected"
                        [disabled]="isProcessing"
                        (change)="onTogglePickerRow(row, $any($event.target).checked)"
                      />
                    </td>
                    <td>
                      <strong>{{ row.subjectCode }}</strong>
                      <span>{{ row.subjectName }}</span>
                      <span
                        *ngIf="row.isSharedWorkload"
                        class="disbursement-revision-dialog-picker-shared-label"
                      >
                        รายวิชาสอนร่วม — แก้ไขทั้งกลุ่มผู้สอนร่วม
                      </span>
                    </td>
                    <td>{{ row.section }}</td>
                    <td>{{ row.teachingType }}</td>
                    <td>{{ row.teachingDays }}</td>
                    <td>{{ row.teachingTimes }}</td>
                    <td>{{ row.roomName }}</td>
                    <td>{{ row.statusLabel }}</td>
                  </tr>
                  <tr *ngIf="row.selected" class="disbursement-revision-dialog-picker-note-row">
                    <td></td>
                    <td colspan="7">
                      <label class="form-label disbursement-revision-dialog-picker-note-label">
                        <span class="disbursement-revision-dialog-picker-note-label-text">
                          เหตุผลส่งกลับแก้ไขของรายวิชานี้
                        </span>
                        <textarea
                          class="form-control disbursement-revision-dialog-picker-note-textarea"
                          rows="3"
                          [value]="pickerRowNote(row)"
                          [disabled]="isProcessing"
                          (input)="onPickerRowNoteChange(row, $event)"
                          placeholder="ระบุเหตุผลหรือสิ่งที่ต้องการแก้ไขของรายวิชานี้"
                        ></textarea>
                      </label>
                      <div
                        *ngIf="shouldShowPickerRowNoteError(row)"
                        class="disbursement-revision-dialog-picker-field-error"
                      >
                        กรุณาระบุเหตุผลของรายวิชานี้
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div
            *ngIf="shouldShowPickerSelectionError()"
            class="disbursement-revision-dialog-picker-field-error"
          >
            กรุณาเลือกรายวิชาที่ต้องการแก้ไข หรือระบุรายละเอียดรายวิชาใหม่ที่ต้องการเพิ่ม
          </div>
        </section>

        <div class="disbursement-revision-dialog-actions">
          <button
            type="button"
            class="btn disbursement-revision-dialog-cancel-button"
            [disabled]="isProcessing"
            (click)="onCancel()"
          >
            {{ cancelText }}
          </button>
          <button
            type="submit"
            class="btn disbursement-revision-dialog-confirm-button"
            [disabled]="isProcessing"
          >
            {{ isProcessing ? 'กำลังดำเนินการ...' : confirmText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
